import { useState } from "react";
import { Img, DemoAction } from "./shared";

const T = [
  { t: "Gesichtsbehandlung", d: "Reinigung, Peeling und eine ruhige Massage – abgestimmt auf Ihr Hautbild.", min: 60, k: "beauty2" },
  { t: "Körpermassage", d: "Entspannende Ganzkörpermassage mit warmen Ölen.", min: 50, k: "beauty3" },
  { t: "Pflege-Ritual", d: "Kombination aus Gesichts- und Handpflege mit Naturprodukten.", min: 90, k: "beauty1" },
];

export default function Beauty({ wide, onCta }) {
  const [sel, setSel] = useState(0);
  const cur = T[sel];
  return (
    <div className="bg-[#F3EEE7] text-[#4A4238]" style={{ fontFamily: "'Lora Variable', serif" }}>
      <header className="px-6 pt-12 pb-2 text-center" style={wide ? { paddingTop: 30 } : undefined}>
        <span className="text-[24px] tracking-[0.2em] text-[#6B7B5E]" style={{ fontFamily: "Italiana, serif" }}>ATELIER SALBEI</span>
      </header>
      <section className={wide ? "grid grid-cols-2 items-center gap-12 px-14 py-12" : "px-6 py-6"}>
        <div className={`overflow-hidden rounded-[200px_200px_12px_12px] ${wide ? "h-[460px]" : "h-[340px]"}`}><Img k="beauty1" alt="Pflegeprodukte" /></div>
        <div className={wide ? "" : "mt-7 text-center"}>
          <p className="text-[12px] uppercase tracking-[0.3em] text-[#6B7B5E]">Kosmetik & Wohlbefinden</p>
          <h1 className={`mt-3 leading-[1.05] ${wide ? "text-[56px]" : "text-[38px]"}`} style={{ fontFamily: "Italiana, serif" }}>Zeit für<br />sich selbst.</h1>
          <p className="mt-4 text-[14px] italic leading-relaxed">Ruhige Räume, natürliche Pflege und Behandlungen ohne Eile.</p>
        </div>
      </section>
      <section className={wide ? "px-14 pb-16" : "px-6 pb-12"}>
        <h2 className="text-center text-[26px]" style={{ fontFamily: "Italiana, serif" }}>Behandlung wählen</h2>
        <div className="mt-5 space-y-2.5">
          {T.map((x, i) => (
            <button key={x.t} type="button" data-noswipe aria-pressed={sel === i} onClick={() => setSel(i)}
              className={`flex w-full items-center justify-between rounded-full border px-5 py-3 text-left text-[14px] transition-colors ${sel === i ? "border-[#6B7B5E] bg-[#6B7B5E] text-white" : "border-[#D8CFC2] bg-transparent"}`}>
              <span>{x.t}</span><span className="text-[12px] opacity-80">{x.min} Min.</span>
            </button>
          ))}
        </div>
        <div className={`mt-6 rounded-2xl bg-white/70 p-4 ${wide ? "grid grid-cols-[180px_1fr] gap-5" : ""}`}>
          <div className={`overflow-hidden rounded-xl ${wide ? "h-[140px]" : "h-[150px]"}`}><Img k={cur.k} alt={cur.t} /></div>
          <div className={wide ? "" : "mt-3"}>
            <h3 className="text-[18px]">{cur.t}</h3>
            <p className="mt-1 text-[13px] leading-relaxed">{cur.d}</p>
            <DemoAction label="Termin wählen" onCta={onCta} className="mt-3 rounded-full bg-[#4A4238] px-5 py-2.5 text-[13px] text-white" />
          </div>
        </div>
      </section>
    </div>
  );
}
